<template>
  <div>
    <div v-show="loading">
      <Loading />
    </div>
    <div v-if="errored">
      <ErrorPage />
    </div>
    <div v-else-if="notfound">
      <NotFound titulo="Tipos de Cardápio" />
    </div>
    <div v-else-if="DadosEstabelecimento != null">
      <Banner></Banner>

      <div class="content-size section-home s-category">
        <div class="heading-section">
          <div class="sa-title popcat">{{ $t('Cardapios') }}</div>
        </div>
        <div class="home-category-list">
          <div
            class="home-box-category-50"
            v-for="(tipo, i) in tiposCardapio"
            :key="i"
            style="cursor: pointer;"
          >
            <router-link
              :to="tipo.compartilhar ? { name: 'Cardapios-Produtos', query: { m: tipo.compartilhar['tipo-cardapio'], e: tipo.compartilhar.estabelecimentoId }} : { name: 'Cardapios-Produtos', query: { m: tipo.id } }"
            >
              <div class="home-text-category">
                <div class="bc-text2">
                  <a href="#">{{ retornaNomeIdioma(tipo) }}</a>
                </div>
              </div>
              <div class="fundo-preto-opacity"></div>
              <div class="home-image-category">
                <template v-if="tipo.fundo_imagem">
                  <div>
                    <Imagem :key="tipo.fundo_imagem" :caminhoImagem="tipo.fundo_imagem"></Imagem>
                  </div>
                </template>
                <template v-else>
                  <div>
                    <img :src="require('@/assets/img/' + tipo.fundo)" :alt="tipo.nome" />
                  </div>
                </template>
              </div>
            </router-link>
          </div>
        </div>
      </div>

      <div class="content-size section-home s-category">
        <div v-if="paginaEstacionamento || paginaFilaEspera || paginaAreaPet">
          <div class="heading-section">
            <div class="sa-title popcat">{{ $t('NossosServicos') }}</div>
          </div>

          <div class="section-profile">
            <div class="probox">
              <router-link :to="{ name: 'Cardapios-Estacionamento' }" v-if="paginaEstacionamento">
                <div class="bx-col">
                  <div class="bx-col-in">
                    <div class="imagem-servico">
                      <font-awesome-icon :icon="['fas', 'parking']" size="2x" />
                    </div>
                    {{ $t('Estacionamento') }}
                    <div class="count">{{ $t('SaibaMais') }}</div>
                  </div>
                </div>
              </router-link>
              <router-link :to="{ name: 'Cardapios-FilaEspera' }" v-if="paginaFilaEspera">
                <div class="bx-col">
                  <div class="bx-col-in border-center">
                    <div class="imagem-servico">
                      <font-awesome-icon :icon="['fas', 'clock']" size="2x" />
                    </div>
                    {{ $t('FilaDeEspera') }}
                    <div class="count">{{ $t('SaibaMais') }}</div>
                  </div>
                </div>
              </router-link>
              <router-link :to="{ name: 'Cardapios-AreaPet' }" v-if="paginaAreaPet">
                <div class="bx-col">
                  <div class="bx-col-in">
                    <div class="imagem-servico">
                      <font-awesome-icon :icon="['fas', 'paw']" size="2x" />
                    </div>
                    {{ $t('AreaPet') }}
                    <div class="count">{{ $t('SaibaMais') }}</div>
                  </div>
                </div>
              </router-link>
              <div class="clear"></div>
            </div>
          </div>
        </div>

        <div class="heading-section">
          <div class="sa-title popcat">{{ $t('VejaMais') }}</div>
        </div>
        <div class="home-category-list">
          <div class="home-box-category" style="cursor: pointer;" v-if="paginaHappyPromo">
            <router-link :to="{ name: 'Cardapios-HappyPromocoes' }">
              <div class="home-text-category">
                <div class="home-icone">
                  <font-awesome-icon :icon="['far', 'laugh-beam']" size="2x" pull="right" />
                </div>
                <div class="bc-text">
                  <a href="#">{{ $t('HappyEPromocoes') }}</a>
                </div>
              </div>
            </router-link>
          </div>
          <div class="home-box-category" style="cursor: pointer;">
            <div class="home-text-category">
              <div class="home-icone">
                <font-awesome-icon :icon="['fas', 'glass-cheers']" size="2x" pull="right" />
              </div>
              <div class="bc-text">
                <a
                  :href="
                    `https://api.whatsapp.com/send?phone=55` +
                      DadosEstabelecimento.celularWhatsApp +
                      `&text=` + $t('OlaGostariaInformacoesEventos')
                  "
                  target="_blank"
                >{{ $t('Eventos') }}</a>
              </div>
            </div>
          </div>
          <div class="home-box-category" style="cursor: pointer;">
            <div class="home-text-category">
              <div class="home-icone">
                <font-awesome-icon :icon="['far', 'calendar-alt']" size="2x" pull="right" />
              </div>
              <div class="bc-text">
                <a
                  href="https://widget.getinapp.com.br/g6GD8Ak0"
                  target="_blank"
                >{{ $t('Reservas') }}</a>
              </div>
            </div>
          </div>
          <div class="home-box-category" style="cursor: pointer;" v-if="linkIfood">
            <div class="home-text-category">
              <div class="home-icone">
                <font-awesome-icon :icon="['fas', 'biking']" size="2x" pull="right" />
              </div>
              <div class="bc-text">
                <a :href="linkIfood" target="_blank">{{ $t('DeliveryIfood') }}</a>
              </div>
            </div>
          </div>
          <div class="home-box-category" style="cursor: pointer;">
            <div class="home-text-category">
              <div class="home-icone">
                <font-awesome-icon :icon="['fab', 'whatsapp']" size="2x" pull="right" />
              </div>
              <div class="bc-text">
                <a
                  :href="
                    `https://api.whatsapp.com/send?phone=55` +
                      DadosEstabelecimento.celularWhatsApp +
                      `&text=` + $t('OlaGostariaInformacoes')
                  "
                  target="_blank"
                >{{ $t('Informacoes') }}</a>
              </div>
            </div>
          </div>
          <div class="home-box-category" style="cursor: pointer;" v-if="linkWaze">
            <div class="home-text-category">
              <div class="home-icone">
                <font-awesome-icon :icon="['fab', 'waze']" size="2x" pull="right" />
              </div>
              <div class="bc-text">
                <a :href="linkWaze" target="_blank">{{ $t('Waze') }}</a>
              </div>
            </div>
          </div>
          <div class="home-box-category" style="cursor: pointer;" v-if="linkTripAdvisor">
            <div class="home-text-category">
              <div class="home-icone">
                <font-awesome-icon :icon="['fab', 'tripadvisor']" size="2x" pull="right" />
              </div>
              <div class="bc-text">
                <a :href="linkTripAdvisor" target="_blank">{{ $t('TripAdvisor') }}</a>
              </div>
            </div>
          </div>
          <div class="home-box-category" style="cursor: pointer;" v-if="linkPesquisaSatisfacao">
            <div class="home-text-category">
              <div class="home-icone">
                <font-awesome-icon :icon="['far', 'clipboard']" size="2x" pull="right" />
              </div>
              <div class="bc-text">
                <a :href="linkPesquisaSatisfacao" target="_blank">{{ $t('PesquisaDeSatisfacao') }}</a>
              </div>
            </div>
          </div>
          <div class="home-box-category" style="cursor: pointer;" v-if="paginaFormasPagto">
            <router-link :to="{ name: 'Cardapios-FormasPagamento' }">
              <div class="home-text-category">
                <div class="home-icone">
                  <font-awesome-icon :icon="['far', 'credit-card']" size="2x" pull="right" />
                </div>
                <div class="bc-text">
                  <a href="#">{{ $t('FormasDePagamento') }}</a>
                </div>
              </div>
            </router-link>
          </div>
        </div>
      </div>

      <RedesSociais />
    </div>
  </div>
</template>

<script>
import Banner from '@/views/cardapios/components/Banner';
import Imagem from "@/components/Imagem";
import RedesSociais from '@/views/cardapios/components/RedesSociais';
import ErrorPage from '@/components/template/ErrorPage';
import NotFound from '@/components/template/NotFound';
import Loading from '@/components/template/Loading';

import FunctionsMixin from '@/utils/functionsMixin.js'

export default {
  name: 'Cardapios-TiposCardapio',
  components: {
    Banner,
    Imagem,
    RedesSociais,
    ErrorPage,
    NotFound,
    Loading
  },

  mixins: [FunctionsMixin],

  props: {
    EstabelecimentoId: {
      type: String,
      required: true
    },
    DadosEstabelecimento: {
      type: Object
    }
  },

  data() {
    return {
      tiposCardapio: null,
      loading: false,
      errored: false,
      notfound: false
    };
  },

  watch: {
    EstabelecimentoId: function (newVal) {
      this.obterTiposCardapio(newVal);
    }
  },

  computed: {
    paginaEstacionamento() {
      return this.$store.state.configuracoes === null
        ? false
        : this.$store.state.configuracoes.paginas.pagina.estacionamento;
    },
    paginaFilaEspera() {
      return this.$store.state.configuracoes === null
        ? false
        : this.$store.state.configuracoes.paginas.pagina.filaespera;
    },
    paginaAreaPet() {
      return this.$store.state.configuracoes === null
        ? false
        : this.$store.state.configuracoes.paginas.pagina.areapet;
    },
    paginaHappyPromo() {
      return this.$store.state.configuracoes === null
        ? false
        : this.$store.state.configuracoes.paginas.pagina.happypromo;
    },
    paginaFormasPagto() {
      return this.$store.state.configuracoes === null
        ? false
        : this.$store.state.configuracoes.paginas.pagina.formaspagto;
    },
    linkIfood() {
      return this.$store.state.configuracoes === null
        ? false
        : this.$store.state.configuracoes.links.link.ifood;
    },
    linkWaze() {
      return this.$store.state.configuracoes === null
        ? false
        : this.$store.state.configuracoes.links.link.waze;
    },
    linkTripAdvisor() {
      return this.$store.state.configuracoes === null
        ? false
        : this.$store.state.configuracoes.links.link.tripadvisor;
    },
    linkPesquisaSatisfacao() {
      return this.$store.state.configuracoes === null
        ? null
        : this.$store.state.configuracoes.links.link.pesquisasatisfacao;
    }
  },

  created() {
    if (this.EstabelecimentoId != '')
      this.obterTiposCardapio(this.EstabelecimentoId);
  },

  methods: {
    async obterTiposCardapio(estabelecimentoId) {
      try {
        this.tiposCardapio = [];

        await this.$firebase
          .firestore()
          .collection('estabelecimentos')
          .doc(estabelecimentoId)
          .collection('tipos-cardapio')
          .where("ativo", "==", true)
          .where("removido", "==", false)
          .orderBy('ordenar')
          .get()
          .then(snapshot => {
            snapshot.forEach(doc => {
              if (this.exibeCardapio(doc.data().diaSemana, doc.data().horarioSemana)) {
                this.tiposCardapio.push({
                  id: doc.id,
                  nome: doc.data().nome,
                  nomeIdioma: doc.data().nomeIdioma,
                  icone: doc.data().icone,
                  fundo: doc.data().fundo,
                  fundo_imagem: doc.data().fundo_imagem,
                  diaSemana: doc.data().diaSemana,
                  horarioSemana: doc.data().horarioSemana,
                  compartilhar: doc.data().compartilhar
                });
              }
            });
          })
          .catch(err => {
            console.log('Erro Firebase (obterTiposCardapio)', err);
            this.errored = true;
          })
          .finally(() => (this.loading = false));

      } catch (err) {
        console.log('Erro Firebase (obterTiposCardapio)', err);
        this.errored = true;
      }
    },
    linkCardapio(tipo) {
      this.$router.push({
        name: 'Cardapios-Produtos',
        query: { m: tipo }
      });
    },
    exibeCardapio(diaSemana, horarioSemana) {
      if (diaSemana) {
        if (diaSemana.includes(new Date().getDay())) {
          if (horarioSemana) {
            var dataAtual = new Date();
            var diaAtual = dataAtual.getDate();
            var mesAtual = dataAtual.getMonth();
            var anoAtual = dataAtual.getFullYear();

            var dataInicio = new Date(anoAtual, mesAtual, diaAtual, horarioSemana.inicio.toDate().getHours(), horarioSemana.inicio.toDate().getMinutes(), 0);
            var dataTermino = new Date(anoAtual, mesAtual, diaAtual, horarioSemana.termino.toDate().getHours(), horarioSemana.termino.toDate().getMinutes(), 0);

            if (dataInicio <= dataAtual && dataTermino >= dataAtual)
              return true;
            else
              return false;
          } else { return false; }
        } else { return false; }
      } else { return true; }
    },
    retornaNomeIdioma(objecto) {
      const locale = this.$i18n.locale
      if (objecto.nomeIdioma) return objecto.nomeIdioma[locale]
      else return objecto.nome
    }
  }
};
</script>

<style scoped>
.fundo-preto-opacity {
  position: absolute;
  /* background-color: black; */
  background-image: linear-gradient(
    transparent,
    black,
    black,
    black,
    transparent
  );
  width: 100%;
  height: 50px;
  margin: 0 auto;
  z-index: 1;
  top: 50%;
  transform: translateY(-25px);
  opacity: 0.3;
}

.bc-text {
  font-size: 15px !important;
}

.bc-text2 {
  font-size: 15px !important;
}

.bc-text2 a {
  color: #ffffff;
}

.bc-text2 a:hover {
  color: #ffffff;
}

.home-box-category {
  border: 1px solid #cccccc !important;
  margin-bottom: 15px;
}

.home-icone {
  position: absolute;
  top: 50%;
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
}

.home-icone img {
  width: 50%;
}

.imagem-servico {
  padding-bottom: 8px;
}

.imagem-servico img {
  width: 30px;
}

.count {
  font-weight: 500;
  font-size: 10px;
}
</style>
